export const SET_DATA_TABLE = "SET_DATA_TABLE";
export const SET_EMPTY_TABLE = "SET_EMPTY_TABLE";
export const SET_LEGENDA_MAPS = "SET_LEGENDA_MAPS";
export const SW_INIT = "SW_INIT";
export const SW_UPDATE = "SW_UPDATE";
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const SET_PROGRESS_UPLOAD = "SET_PROGRESS_UPLOAD";
export const SET_TRIGGER_TABLE = "SET_TRIGGER_TABLE";
